import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChargepointSummaryItem } from 'brain-data/model/chargepoint.model';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export const CHARGEPOINT_URL = `${environment.apiBaseUrl}/chargepoint/summary`;
export const CHARGEPOINT_SYNC_URL = `${environment.apiBaseUrl}/chargepoint/sync`;

export interface ChargepointSyncResponse {
  status: string;
  tenantId: string;
  fromTimeStamp?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class ChargepointService {
  constructor(private http: HttpClient) {}

  getChargePointSummary(fromTimeStamp: string, toTimeStamp: string): Observable<ChargepointSummaryItem[]> {
    const params = new HttpParams().set('fromTimeStamp', fromTimeStamp).set('toTimeStamp', toTimeStamp);
    return this.http.get<ChargepointSummaryItem[]>(CHARGEPOINT_URL, { params });
  }

  /** One-shot / re-backfill trigger. Daily incremental sync also runs server-side. */
  syncSessions(fromTimeStamp?: string): Observable<ChargepointSyncResponse> {
    let params = new HttpParams();
    if (fromTimeStamp) {
      params = params.set('fromTimeStamp', fromTimeStamp);
    }
    return this.http.post<ChargepointSyncResponse>(CHARGEPOINT_SYNC_URL, null, { params });
  }
}
